import React from 'react';

import BenchlingConfig from 'BenchlingConfig';

import UploadDropdownButton from './UploadDropdownButton';

type UploadDropdownButtonProps = React.ComponentProps<typeof UploadDropdownButton>;

/**
 * Flag gate for the "Upload a File" dropdown.
 *
 * Renders the redirect-oriented (backend OAuth popup) UploadDropdownButton when
 * `ELN_ENABLE_REDIRECT_ORIENTED_GOOGLE_DRIVE_FILE_PICKER` is enabled, and nothing
 * otherwise. Call sites import this switch rather than UploadDropdownButton
 * directly so the flag decision has a single owner and UploadDropdownButton itself
 * does not need to re-check it.
 */
export default function UploadDropdownButtonSwitch(props: UploadDropdownButtonProps): JSX.Element | null {
  if (!BenchlingConfig.ELN_ENABLE_REDIRECT_ORIENTED_GOOGLE_DRIVE_FILE_PICKER) {
    return null;
  }
  return <UploadDropdownButton {...props} />;
}
